// extracted by mini-css-extract-plugin
export default {"main":"Home_main__Sg46B","Home":"Home_Home__I2ulA","Tabs":"Home_Tabs__eil+M","active":"Home_active__T83eH","menuTab":"Home_menuTab__Pn8p1","Mobile":"Home_Mobile__27mMw"};